export const MATTER_TYPES = ["family_law", "conveyancing", "commercial", "litigation", "wills_estates", "other"];
export const ACTIVITY_TYPES = ["attendance", "correspondence", "drafting", "research", "court_appearance", "telephone", "other"];
export const LEAD_STATUSES = ["New", "Contacted", "Proposal Sent", "Engaged", "Lost"];
export const MATTER_STATUSES = ["Open", "On Hold", "Closed"];
export const COURT_EVENT_TYPES = ["hearing", "mention", "filing_deadline", "directions", "other"];
export const COURT_STATUSES = ["Upcoming", "Filed", "Completed", "Adjourned"];
export const APPT_TYPES = ["client_meeting", "consultation", "court", "internal_meeting", "mediation", "other"];
export const KYC_DOC_TYPES = ["driver_licence", "passport"];
export const KYC_STATUSES = ["Pending", "Verified", "Rejected"];
export const FEE_STRUCTURES = ["hourly", "fixed_fee", "contingency"];
export const BILLING_ROLES = ["partner", "associate", "paralegal", "support"];
export const ROLES = ["admin", "lawyer", "support"];
export const opts = (arr, fn) => arr.map((v) => ({ value: v, label: fn ? fn(v) : v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) }));
